import { useState, useEffect } from 'react';
import { checkVideoCookieConsent } from '../utils/CookieConsent'

/**
 * Custom hook to track and sync video cookie consent.
 * @returns {boolean} Current consent status
 */

export const useVideoConsent = (): boolean => {
    const [hasConsent, setHasConsent] = useState<boolean>(false);

    useEffect(() => {
        let isMounted = true;

        const syncConsent = async (): Promise<void> => {
            const consent: boolean = await checkVideoCookieConsent();

            if (!isMounted) return;

            setHasConsent((prev: boolean) => (prev === consent ? prev : consent));
        };

        const handlePageVisible = (): void => {
            if (document.visibilityState === 'visible') {
                void syncConsent();
            }
        };

        void syncConsent();

        const intervalId: ReturnType<typeof setInterval> = setInterval(() => {
            void syncConsent();
        }, 1500);

        window.addEventListener('focus', handlePageVisible);
        document.addEventListener('visibilitychange', handlePageVisible);

        return () => {
            isMounted = false;
            clearInterval(intervalId);
            window.removeEventListener('focus', handlePageVisible);
            document.removeEventListener('visibilitychange', handlePageVisible);
        };
    }, []);

    return hasConsent;
};
